import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { Activity } from "../types/activity";

async function fetchTaskActivities(taskId: string) {
  return await httpClient.tasks.get<Activity[]>(
    `/v1/task/${taskId}/activities`
  );
}

export function useTaskActivities(taskId: string) {
  return useQuery<Activity[]>({
    queryKey: ["task", "activities", taskId],
    queryFn: async () => await fetchTaskActivities(taskId),
    staleTime: INTERVAL.HOUR,
    enabled: !!taskId,
  });
}
